<template>
    <v-container fluid class="px-0">
        <v-list flat>
            <v-list-item three-line>
                <v-list-item-avatar>
                    <v-icon style="background-color: gainsboro !important; color: black">bx bxs-message</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title>
                        <strong style="font-size: 1rem">Feedbacks</strong>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                        <v-tabs v-model="tab" ref="tabs" show-arrows>
                            <v-tab v-for="(item, index) in tabs" :key="item.id || index" class="text-none mr-2"
                                style="letter-spacing: 0.5px">
                                <small style="font-weight: 900; font-size: 0.8rem">
                                    {{ item.tab }}
                                </small>
                            </v-tab>
                        </v-tabs>
                        <v-divider />
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </v-list>
        <v-tabs-items v-model="tab">
            <v-tab-item>
                <FeedbackAndSuggestion />
            </v-tab-item>
            <!-- <v-tab-item>
            <CompanyTreeView
                :tasks="assignedTasks"
                :header="header_assigned"
                :getStatuses="getStatuses"
            />
        </v-tab-item> -->
        </v-tabs-items>
    </v-container>
</template>

<script>
/**components */
import FeedbackAndSuggestion from "./FeedbackAndSuggestion.vue";

export default {
    components: {
        FeedbackAndSuggestion,
    },
    data: () => ({
        tab: 0,
        tabs: [
            { tab: "Feedbacks & Suggestions" },
            // { tab: "Assigned Tasks" },
            // { tab: "Goals" }
        ],
    }),
};
</script>
